module.exports = __webpack_public_path__ + "static/media/primary.c859da43.jpeg";